import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, updateDoc, doc, query, Timestamp, limit, where } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useAuth } from "../../../context/AuthContext";
import { getCollectionLabel, getFieldLabel, getFieldPathLabel } from "../utils/fieldLabels";

const HakedisTanimlari = () => {
  const { user } = useAuth();
  const [tanimlar, setTanimlar] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [availableFields, setAvailableFields] = useState({});
  const [uniqueValues, setUniqueValues] = useState({});
  
  const collectionsToFetch = [
    "hazirbeton_mikser_sevkiyat",
    "hazirbeton_pompa_hakedis",
    "hazirbeton_zone_uretim",
    "fuel_transactions", 
    "kazalar",           
    "issues",            
    "faturalar",         
    "plates",
    "personeller",
    "mazot_fiyatlari"
  ];

  const [newTanim, setNewTanim] = useState({
    baslik: "", tip: "arac", aktif: true, kurallar: [], ekBaglantilar: [], history: []
  });

  useEffect(() => {
    fetchTanimlar();
    fetchFields();
  }, []);

  const fetchTanimlar = async () => {
    const q = query(collection(db, "hakedis_tanimlari"), where("silindi", "==", false));
    const snap = await getDocs(q);
    setTanimlar(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const fetchFields = async () => {
    const fieldMap = {};
    const valMap = {};
    for (const colId of collectionsToFetch) {
      try {
        const snap = await getDocs(query(collection(db, colId), limit(500)));
        if (!snap.empty) {
          const docs = snap.docs.map(d => d.data());
          const keys = [...new Set(docs.flatMap(d => Object.keys(d || {})))].sort((a, b) => a.localeCompare(b, "tr"));
          fieldMap[colId] = keys;
          keys.forEach(key => {
            const values = [...new Set(docs.map(d => d[key]?.toString()).filter(Boolean))];
            if (values.length > 0 && values.length <= 20) valMap[`${colId}:${key}`] = values;
          });
        }
      } catch (e) { console.error(`${colId} alanları okunamadı`); }
    }
    setAvailableFields(fieldMap);
    setUniqueValues(valMap);
  };

  // DÜZELTME 3: Kaydetme öncesi veri temizliği (Payload koruması)
  const handleSave = async () => {
    if (!newTanim.baslik) return alert("Başlık giriniz!");
    setLoading(true);
    
    const log = { user: user?.email, date: Timestamp.now(), action: editingId ? "Güncellendi" : "Oluşturuldu" };
    
    const payload = { 
        ...newTanim, 
        ekBaglantilar: newTanim.ekBaglantilar || [], // Boş dizi garantisi
        kurallar: newTanim.kurallar || [],           // Boş dizi garantisi
        updatedBy: user?.email, 
        updatedAt: Timestamp.now(), 
        silindi: false, 
        history: [...(newTanim.history || []), log] 
    };

    try {
      if (editingId) await updateDoc(doc(db, "hakedis_tanimlari", editingId), payload);
      else await addDoc(collection(db, "hakedis_tanimlari"), { ...payload, createdAt: Timestamp.now() });
      setShowModal(false);
      fetchTanimlar();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const getUniqueOptions = (fieldPath) => {
    if (!fieldPath || !fieldPath.includes(".")) return [];
    const [colId, ...fieldParts] = fieldPath.split(".");
    return uniqueValues[`${colId}:${fieldParts.join(".")}`] || [];
  };

  const getFilterValuePath = (collectionId, fieldName) => {
    if (!fieldName) return "";
    return String(fieldName).includes(".") ? fieldName : `${collectionId}.${fieldName}`;
  };

  const allFieldOptions = Object.keys(availableFields).flatMap(col =>
    (availableFields[col] || []).map(field => ({ col, field, value: `${col}.${field}` }))
  );
  const recommendedAnaAlanOptions = [
    { value: "personelAdi", label: "Personel" },
    { value: "soforAdi", label: "Sürücü" },
    { value: "operatorAdi", label: "Operatör" },
    { value: "yagciAdi", label: "Yağcı" },
    { value: "mikserPlaka", label: "Mikser Plaka" },
    { value: "pompaPlaka", label: "Pompa Plaka" },
    { value: "tesis", label: "Tesis" },
    { value: "tarih", label: "Tarih" },
    { value: "irsaliyeNo", label: "İrsaliye No" }
  ];
  const recommendedAnaAlanValues = new Set(recommendedAnaAlanOptions.map(o => o.value));
  const sourceAnaAlanOptions = allFieldOptions.filter(o => !recommendedAnaAlanValues.has(o.field));

  return (
    <div style={{ padding: "20px 40px", maxWidth: 1400, margin: "auto", fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 30 }}>
        <h2 style={{ color: "#1e293b", fontWeight: 800 }}>Hakediş & Prim Sözleşme Motoru</h2>
        <button onClick={() => { setEditingId(null); setNewTanim({ baslik: "", tip: "arac", kurallar: [], ekBaglantilar: [], history: [] }); setShowModal(true); }} 
                style={{ background: "#2563eb", color: "white", padding: "12px 24px", border: "none", borderRadius: 10, cursor: "pointer", fontWeight: 600 }}>
          + Yeni Sözleşme Tanımla
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", gap: 25 }}>
        {tanimlar.map(t => (
          <div key={t.id} style={{ border: "1px solid #e2e8f0", padding: 25, borderRadius: 20, background: "white", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
            <h3 style={{ margin: "0 0 10px 0", color: "#334155" }}>{t.baslik}</h3>
            {/* DÜZELTME 1: Düzenle butonu veriyi yüklerken eksik alanları tamamlar */}
            <button onClick={() => { 
                setEditingId(t.id); 
                setNewTanim({
                  ...t, 
                  ekBaglantilar: t.ekBaglantilar || [], 
                  kurallar: t.kurallar || []
                }); 
                setShowModal(true); 
            }} style={{ width: "100%", marginTop: 20, padding: 10, borderRadius: 10, border: "1px solid #e2e8f0", background: "#f8fafc", cursor: "pointer", fontWeight: 600 }}>Düzenle</button>
          </div>
        ))}
      </div>

      {showModal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(15, 23, 42, 0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, backdropFilter: "blur(6px)" }}>
          <div style={{ background: "white", padding: 40, borderRadius: 24, width: "95%", maxWidth: 1200, maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 30 }}>
                <h2>{editingId ? "Sözleşmeyi Düzenle" : "Yeni Sözleşme"}</h2>
                <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", fontSize: 24, cursor: "pointer" }}>✕</button>
            </div>
            
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 20, marginBottom: 30 }}>
              <input placeholder="Sözleşme Adı" style={{ padding: 15, borderRadius: 12, border: "1px solid #cbd5e1" }} value={newTanim.baslik} onChange={e => setNewTanim({...newTanim, baslik: e.target.value})} />
              <select style={{ padding: 15, borderRadius: 12, border: "1px solid #cbd5e1" }} value={newTanim.tip} onChange={e => setNewTanim({...newTanim, tip: e.target.value})}>
                <option value="arac">Araç / Pompa Hakedişi</option>
                <option value="personel">Personel Prim Sözleşmesi</option>
              </select>
            </div>

            <div style={{ marginBottom: 30, padding: 20, background: "#f1f5f9", borderRadius: 20 }}>
              <h4 style={{ marginTop: 0 }}>🔗 Ek Veri Bağlantıları (Mazot, Kaza, Arıza vb.)</h4>
              {newTanim.ekBaglantilar?.map((ek, ekIdx) => (
                <div key={ekIdx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 0.8fr 0.2fr", gap: 10, marginBottom: 10, background: "white", padding: 15, borderRadius: 12 }}>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>ETİKET</label>
                    {/* DÜZELTME 2: Input değişim mantığı güvenli kopya ile */}
                    <input 
                        placeholder="Örn: Mazot Litre" 
                        value={ek.etiket || ""} 
                        onChange={e => { 
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], etiket: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya}); 
                        }} 
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>ANA ALAN</label>
                    <select
                        value={ek.anaAlan || ""}
                        onChange={e => {
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], anaAlan: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya});
                        }}
                    >
                      <option value="">SeÃ§iniz...</option>
                      <optgroup label="Önerilen Alanlar">
                        {recommendedAnaAlanOptions.map(o => <option key={`ana-rec-${o.value}`} value={o.value}>{o.label}</option>)}
                      </optgroup>
                      <optgroup label="Veri Kaynağı Alanları">
                        {sourceAnaAlanOptions.map(o => <option key={`ana-${o.value}`} value={o.field}>{getFieldPathLabel(o.value)}</option>)}
                      </optgroup>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>KOLEKSİYON</label>
                    <select 
                        value={ek.koleksiyon || ""} 
                        onChange={e => { 
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], koleksiyon: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya}); 
                        }}
                    >
                      <option value="">Seçiniz...</option>
                      {collectionsToFetch.map(c => <option key={c} value={c}>{getCollectionLabel(c)}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>EŞLEŞME ALANI</label>
                    <select 
                        value={ek.baglantiAlani || ""} 
                        onChange={e => { 
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], baglantiAlani: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya}); 
                        }}
                    >
                      <option value="">Seçiniz...</option>
                      {availableFields[ek.koleksiyon]?.map(f => <option key={f} value={f}>{getFieldLabel(f)}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>HEDEF ALAN</label>
                    <select 
                        value={ek.hedefAlan || ""} 
                        onChange={e => { 
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], hedefAlan: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya}); 
                        }}
                    >
                      <option value="">Seçiniz...</option>
                      {availableFields[ek.koleksiyon]?.map(f => <option key={f} value={f}>{getFieldLabel(f)}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 10, fontWeight: 800 }}>ISLEM</label>
                    <select
                        value={ek.islem || "sum"}
                        onChange={e => {
                            const kopya = [...newTanim.ekBaglantilar];
                            kopya[ekIdx] = { ...kopya[ekIdx], islem: e.target.value };
                            setNewTanim({...newTanim, ekBaglantilar: kopya});
                        }}
                    >
                      <option value="sum">Toplam</option>
                      <option value="count">Adet</option>
                      <option value="first">Ilk Deger</option>
                    </select>
                  </div>
                  <button onClick={() => { const b = [...newTanim.ekBaglantilar]; b.splice(ekIdx, 1); setNewTanim({...newTanim, ekBaglantilar: b}); }} style={{ color: "red", border: "none", background: "none", cursor: "pointer", marginTop: 15 }}>✕</button>
                  <div style={{ gridColumn: "1 / -1", borderTop: "1px solid #e2e8f0", paddingTop: 12 }}>
                    <label style={{ fontSize: 10, fontWeight: 800, display: "block", marginBottom: 8 }}>EK VERİ FİLTRELERİ</label>
                    {(ek.filtreler || []).map((f, fIdx) => (
                      <div key={fIdx} style={{ display: "grid", gridTemplateColumns: "1fr 80px 1fr 36px", gap: 8, marginBottom: 8 }}>
                        <select
                          value={f.alan || ""}
                          onChange={e => {
                            const kopya = [...newTanim.ekBaglantilar];
                            const filtreler = [...(kopya[ekIdx].filtreler || [])];
                            filtreler[fIdx] = { ...filtreler[fIdx], alan: e.target.value };
                            kopya[ekIdx] = { ...kopya[ekIdx], filtreler };
                            setNewTanim({...newTanim, ekBaglantilar: kopya});
                          }}
                        >
                          <option value="">Alan Seçin</option>
                          <optgroup label={getCollectionLabel(ek.koleksiyon)}>
                            {availableFields[ek.koleksiyon]?.map(field => <option key={field} value={field}>{getFieldLabel(field)}</option>)}
                          </optgroup>
                          {ek.koleksiyon === "fuel_transactions" && (
                            <optgroup label="Araç Kartları">
                              {availableFields.plates?.map(field => <option key={`plates.${field}`} value={`plates.${field}`}>{getFieldLabel(field)}</option>)}
                            </optgroup>
                          )}
                        </select>
                        <select
                          value={f.op || "=="}
                          onChange={e => {
                            const kopya = [...newTanim.ekBaglantilar];
                            const filtreler = [...(kopya[ekIdx].filtreler || [])];
                            filtreler[fIdx] = { ...filtreler[fIdx], op: e.target.value };
                            kopya[ekIdx] = { ...kopya[ekIdx], filtreler };
                            setNewTanim({...newTanim, ekBaglantilar: kopya});
                          }}
                        >
                          <option value="==">=</option><option value="!=">!=</option><option value=">">&gt;</option><option value="<">&lt;</option><option value=">=">&gt;=</option><option value="<=">&lt;=</option>
                        </select>
                        <div>
                          <input
                            style={{ width: "100%" }}
                            list={`ek-filter-values-${ekIdx}-${fIdx}`}
                            placeholder="Değer..."
                            value={f.deger || ""}
                            onChange={e => {
                              const kopya = [...newTanim.ekBaglantilar];
                              const filtreler = [...(kopya[ekIdx].filtreler || [])];
                              filtreler[fIdx] = { ...filtreler[fIdx], deger: e.target.value };
                              kopya[ekIdx] = { ...kopya[ekIdx], filtreler };
                              setNewTanim({...newTanim, ekBaglantilar: kopya});
                            }}
                          />
                          {getUniqueOptions(getFilterValuePath(ek.koleksiyon, f.alan)).length > 0 && (
                            <datalist id={`ek-filter-values-${ekIdx}-${fIdx}`}>
                              {getUniqueOptions(getFilterValuePath(ek.koleksiyon, f.alan)).map(v => <option key={v} value={v} />)}
                            </datalist>
                          )}
                        </div>
                        <button
                          onClick={() => {
                            const kopya = [...newTanim.ekBaglantilar];
                            const filtreler = [...(kopya[ekIdx].filtreler || [])];
                            filtreler.splice(fIdx, 1);
                            kopya[ekIdx] = { ...kopya[ekIdx], filtreler };
                            setNewTanim({...newTanim, ekBaglantilar: kopya});
                          }}
                          style={{ color: "#ef4444", background: "none", border: "none", cursor: "pointer" }}
                        >✕</button>
                      </div>
                    ))}
                    <button
                      onClick={() => {
                        const kopya = [...newTanim.ekBaglantilar];
                        const filtreler = [...(kopya[ekIdx].filtreler || []), { alan: "", op: "==", deger: "" }];
                        kopya[ekIdx] = { ...kopya[ekIdx], filtreler };
                        setNewTanim({...newTanim, ekBaglantilar: kopya});
                      }}
                      style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #cbd5e1", background: "#f8fafc", cursor: "pointer", fontSize: 12 }}
                    >+ Filtre Ekle</button>
                  </div>
                </div>
              ))}
              <button onClick={() => setNewTanim({...newTanim, ekBaglantilar: [...(newTanim.ekBaglantilar || []), { etiket: "", anaAlan: "soforAdi", koleksiyon: "", baglantiAlani: "driverName", hedefAlan: "liters", islem: "sum", filtreler: [] }]})} 
                      style={{ padding: "8px 15px", borderRadius: 8, border: "1px solid #2563eb", color: "#2563eb", background: "white", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
                + Başka Koleksiyon Bağla
              </button>
            </div>

            {newTanim.kurallar.map((rule, idx) => (
              <div key={idx} style={{ background: "#f8fafc", padding: 30, borderRadius: 20, marginBottom: 25, border: "1px solid #e2e8f0", position: "relative" }}>
                <h4 style={{ margin: "0 0 20px 0", color: "#64748b" }}>Kural Grubu #{idx + 1}</h4>
                <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr 1fr 1fr 1.5fr", gap: 15, marginBottom: 20 }}>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700 }}>Ana Veri Kaynağı</label>
                    <select value={rule.anaKaynak} onChange={e => { const c = [...newTanim.kurallar]; c[idx].anaKaynak = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                      {collectionsToFetch.map(col => <option key={col} value={col}>{getCollectionLabel(col)}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700 }}>Hesap Birimi</label>
                    <select value={rule.birim} onChange={e => { const c = [...newTanim.kurallar]; c[idx].birim = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                      <option value="m3">m3 / Ton Toplamı</option>
                      <option value="sefer">Benzersiz Sefer Sayısı</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700 }}>{rule.birim === "m3" ? "M3/Ton Alanı" : "Benzersiz Alan (İrsaliye)"}</label>
                    <select value={rule.carpanAlan} onChange={e => { const c = [...newTanim.kurallar]; c[idx].carpanAlan = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                      <option value="">Seçiniz...</option>
                      {availableFields[rule.anaKaynak]?.map(f => <option key={f} value={f}>{getFieldLabel(f)}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700 }}>Katsayı / Tutar</label>
                    <input type="number" value={rule.katsayi} onChange={e => { const c = [...newTanim.kurallar]; c[idx].katsayi = parseFloat(e.target.value); setNewTanim({...newTanim, kurallar: c}); }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, fontWeight: 700 }}>Hesaplama Modu</label>
                    <select value={rule.mod} onChange={e => { const c = [...newTanim.kurallar]; c[idx].mod = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                        <option value="sabit">Sabit</option>
                        <option value="mazot">Mazot Endeksli</option>
                    </select>
                  </div>
                </div>

                <div style={{ background: "white", padding: 20, borderRadius: 15, border: "1px dashed #cbd5e1" }}>
                   <label style={{ fontSize: 12, fontWeight: 700, display: "block", marginBottom: 15 }}>Filtreleme Koşulları</label>
                   {rule.filtreler?.map((f, fIdx) => (
                     <div key={fIdx} style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                        <select style={{ flex: 1 }} value={f.alan} onChange={e => { const c = [...newTanim.kurallar]; c[idx].filtreler[fIdx].alan = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                          <option value="">Alan Seçin</option>
                          {Object.keys(availableFields).map(col => availableFields[col].map(field => (
                            <option key={`${col}.${field}`} value={`${col}.${field}`}>{getFieldPathLabel(`${col}.${field}`)}</option>
                          )))}
                        </select>
                        <select style={{ width: 70 }} value={f.op} onChange={e => { const c = [...newTanim.kurallar]; c[idx].filtreler[fIdx].op = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}>
                          <option value="==">=</option><option value=">">&gt;</option><option value="<">&lt;</option><option value=">=">&gt;=</option><option value="<=">&lt;=</option>
                        </select>
                        <div style={{ flex: 1 }}>
                          <input
                            style={{ width: "100%" }}
                            list={`filter-values-${idx}-${fIdx}`}
                            placeholder="Değer..."
                            value={f.deger}
                            onChange={e => { const c = [...newTanim.kurallar]; c[idx].filtreler[fIdx].deger = e.target.value; setNewTanim({...newTanim, kurallar: c}); }}
                          />
                          {getUniqueOptions(f.alan).length > 0 && (
                            <datalist id={`filter-values-${idx}-${fIdx}`}>
                              {getUniqueOptions(f.alan).map(v => <option key={v} value={v} />)}
                            </datalist>
                          )}
                        </div>
                        <button onClick={() => { const c = [...newTanim.kurallar]; c[idx].filtreler.splice(fIdx, 1); setNewTanim({...newTanim, kurallar: c}); }} style={{ color: "#ef4444", background: "none", border: "none" }}>✕</button>
                     </div>
                   ))}
                   <button onClick={() => { const c = [...newTanim.kurallar]; if(!c[idx].filtreler) c[idx].filtreler = []; c[idx].filtreler.push({ alan: "", op: "==", deger: "" }); setNewTanim({...newTanim, kurallar: c}); }} style={{ padding: "8px 15px", borderRadius: 8, border: "none", background: "#f1f5f9", cursor: "pointer", fontSize: 12 }}>+ Yeni Koşul Ekle</button>
                </div>
                <button onClick={() => { const c = [...newTanim.kurallar]; c.splice(idx, 1); setNewTanim({...newTanim, kurallar: c}); }} style={{ position: "absolute", top: 15, right: 15, color: "#94a3b8", background: "none", border: "none" }}>Grubu Sil</button>
              </div>
            ))}

            <button onClick={() => setNewTanim({...newTanim, kurallar: [...newTanim.kurallar, { anaKaynak: "hazirbeton_mikser_sevkiyat", birim: "m3", carpanAlan: "m3", mod: "sabit", katsayi: 0, filtreler: [] }]})} 
                    style={{ width: "100%", padding: 15, border: "2px dashed #cbd5e1", borderRadius: 15, background: "none", color: "#64748b", fontWeight: 700, cursor: "pointer" }}>+ Yeni Kural Grubu Ekle</button>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 15, marginTop: 40 }}>
              <button onClick={() => setShowModal(false)} style={{ padding: "12px 30px", borderRadius: 12, border: "1px solid #cbd5e1" }}>İptal</button>
              <button onClick={handleSave} disabled={loading} style={{ padding: "12px 40px", borderRadius: 12, border: "none", background: "#2563eb", color: "white", fontWeight: 700 }}>
                {loading ? "Kaydediliyor..." : "Sözleşmeyi Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HakedisTanimlari;
